import React from "react";
import Icon from "../icon";
import type { TableRawIconTips } from "./dto";

const { EditIcon, DeleteIcon, BindIcon, ShowIcon } = Icon;

export const OPERATION_BASIC_KEY = ["edit", "delete", "show"];

/**
 * 行内操作 icon 提示（内置）默认值
 */
export const ROW_ICON_TITLE: TableRawIconTips = {
  bind: "关联",
  delete: "删除",
  edit: "编辑",
  show: "查看",
};
/**
 * 操作列的图标映射
 */
export const ROW_ICON_MAP = {
  bind: (props) => <BindIcon {...props} />,
  delete: (props) => <DeleteIcon {...props} />,
  edit: (props) => <EditIcon {...props} />,
  show: (props) => <ShowIcon {...props} />,
};

/**
 * 导出默认接口前缀
 */
export const TEMPLATE_DOWNLOAD_PRE = "/api/sniper/file/";
